import React from 'react';
import DateTimePicker from "react-widgets/lib/DateTimePicker";
import moment from "moment";
import {PropsObjectType} from "core/form/form";
import {classNames} from "core/common/utils/domUtils";

import 'react-widgets/lib/less/react-widgets.less';
import 'core/components/fields/styledDatePicker.less';



interface StyledDatePickerProps extends PropsObjectType {
  defaultValue?: Date;
  value?: string | number | Date;
  onChange?:  (value: any) => void;
  onToggle?:   (isOpen: boolean) => void;
  min?:     Date;
  max?:     Date;
  calendar?: boolean;
  time?: boolean;
  step?: number;
  placeholder?: string;
  autoFocus?: boolean;
  id?: string;
  hideCalendar?: boolean;
  format?: string;
  disabled?: boolean;
}

interface StyledDatePickerState {
  focused?: boolean;
}

export default class StyledDatePicker extends React.PureComponent<StyledDatePickerProps, StyledDatePickerState> {

  static defaultProps: StyledDatePickerProps = {
      time:             false,
      step:             5,
  };

  _uniqueId: string;

  constructor(props) {
    super(props);

    this.state = {
      focused: false
    }
  }

  componentDidMount() {
    let {name, hintText, floatingLabelText} = this.props;
    this._uniqueId = (name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF)).replace(/[^A-Za-z0-9-]/gi, '');
  }

  onBlurEvent = (e) => {
    this.setState({focused: false});
  };

  onFocusEvent = (e) => {
    this.setState({focused: true});
  };

  onChangeWrapper = (value) => {
    let {onChange, time} = this.props;
    if (onChange) {
      onChange( (!time && value instanceof Date) ? moment(value).format("YYYY-MM-DD") : value );
    }
  };



  render() {

    let {
      defaultValue,
      value,
      onChange,
      onToggle,
      min,
      max,
      calendar,
      time,
      step,
      fullWidth,
      placeholder,
      name,
      autoFocus,
      style,
      errorText,
      floatingLabelStyle,
      floatingLabelText,
      id,
      hideCalendar,
      format,
      disabled,
      ...other
      } = this.props;



    // vytvorim date object
    if (value && !(value instanceof Date)) {
      value = new Date(value as any);
    }

    let inputId = id || this._uniqueId;


    let localStyles: any = {
        position: 'relative',
    };
    if (fullWidth) {
      localStyles.width = "100%";
    }

    let floatingLabelTextElement = floatingLabelText ? (
    <label className="DatePickerLabel"
      htmlFor={inputId}
      style={floatingLabelStyle}>
        {floatingLabelText}
      </label>) : null;



    const _classes = classNames('StyledDatePicker', {
      'is-focused': this.state.focused,
      'is-error': !!errorText,
      'has-value': (value && (value.toString().length > 0)),
      'no-calendar' : hideCalendar
    });

    return (
      <div className={_classes}
           style={Object.assign(localStyles, style)}>
        {floatingLabelTextElement}
        <div style={{position: 'relative', height: '100%'}}>
          <DateTimePicker onFocus={this.onFocusEvent} onBlur={this.onBlurEvent}
            defaultValue={defaultValue}
            value={value as Date}
            onChange={this.onChangeWrapper}
            onToggle={onToggle}
            calendar={calendar}
            time={time}
            step={step}
            min={min}
            max={max}
            placeholder={placeholder}
            format={format}
            disabled={disabled}
          />
          <hr className="underscore underscore-grey" />
          <hr className="underscore underscore-blue" />
        </div>
        {
          ( (errorText) ? (<div className="errorText">{errorText}</div>) : '' )
        }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/core/components/fields/styledDatePicker.tsx